import { FeatureList } from 'core/constants/common';
import Feature from './feature';

export default class CustomAnalytics extends Feature {
  constructor(disabledFeatures: string[]) {
    super(FeatureList.customAnalytics, disabledFeatures);
  }

  isAccessible(): boolean {
    return super.isRouteAccessible();
  }
}
